import { type StatsBarProps, type VoteDistributionProps } from '@capsicum/common';
import { Fragment } from 'react';
import styled from 'styled-components';

import { Divider } from '../../atoms/divider/Divider';
import { StatsBar } from '../stats-bar/StatsBar';

export const VoteDistribution = ({ testID, votes }: VoteDistributionProps) => (
	<S.Container data-testid={testID}>
		{votes &&
			votes.map((vote: StatsBarProps, index: number) => (
				<Fragment key={index}>
					<StatsBar {...vote} />
					{index !== votes.length - 1 && <Divider orientation="horizontal" />}
				</Fragment>
			))}
	</S.Container>
);
namespace S {
	export const Container = styled.div`
		${({ theme }) => theme.border.radius.small};
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
		overflow: hidden;
		padding: 0 ${({ theme }) => theme.spacings.large};
		width: 100%;
	`;
}
